module.exports = __webpack_public_path__ + "static/media/ibtesam.ed652ba3.jpg";